import { VH, VW } from "../../../tiles";
import { openModal } from "../../../ui/containers/Modal";
import { TextButton } from "../../../ui/input/TextButton";
import { ComponentF, createElement } from "../../../ui/ui";
import { HelpModal } from "../home/HelpModal";

export const HelpCallToAction: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  return [
    createElement(
      TextButton,
      { x: 0, y: 0, w: C.bounds.w, h: 1 },
      {
        keys: ["?", "//"],
        title: "Help",
        keyLabel: "?",
        onClick: () => {
          openModal(
            createElement(HelpModal, { x: 0, y: 0, w: VW - 7, h: VH - 7 })
          );
        },
      }
    ),
  ];
};
